export default "__VITE_ASSET__YhW$XZEw__"